// extracted by mini-css-extract-plugin
module.exports = {"currencyHeader":"Currency_currencyHeader__vRFAd","currencyContent":"Currency_currencyContent__cRjCo","icon":"Currency_icon__OXdKw"};